import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
/*----tree structure--*/
import {LOAD_CHILDREN_OPTIONS,Treeselect} from '@riophae/vue-treeselect'
  // import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// import Multiselect from 'vue-multiselect'
// import 'vue-multiselect/dist/vue-multiselect.min.css';
/*----//tree structure--*/
import CategoryTree from './../CategoryTree'


export default {
    name: 'systemprojectroleaccessview',
    components: {
        VueElementLoading,
        Treeselect,
        CategoryTree
    },
    data: function() {
        return {
          projectRoles: [],
          show:false,
        }
    },
    created: function() {

    },
    mounted() {
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.localuserid = userdetail.userid;
        this.getProjectSystemData();

    },
    methods: {

      getProjectSystemData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');
          this.show = true;
          axios({
                  method: 'POST',
                  'url': apiUrl.api_url + 'getActiveRoleModuleList',
                  headers: {
                      'Authorization': 'Bearer ' + myStr
                  }
              })

              .then(async result => {
                this.projectRoles = result.data.data;
                this.show = false;
              }, error => {
                  console.error(error)
              })
      },

    }
}



// WEBPACK FOOTER //
// ./src/views/components/systemprojectroleaccessview/systemprojectroleaccessview.component.js